const Agent = require('../../agent')

class FluxMessage {
  constructor(document) {
    document = document || {}
    this.enabled = typeof document.enabled === 'undefined' ? true : document.enabled
    if (document.sender) {
      this.sender = new Agent(document.sender)
    }
    this.comment = document.comment || ''
  }
}

module.exports = FluxMessage
